// src/Data/ItineraryData.js

const itineraries = {
  Kerela: [
    {
      day: "Day 01",
      title: "Arrive Guruvayur",
      content:
        "After your arrival at Trichur Railway / Cochin Airport, our tour representatives will welcome and transfer you to the hotel. Get into the hotel and relax for sometime. In the evening, join in the darshan at Sri Krishna Temple located at Guruvayur. Spend your overnight stay at hotel."
    },
    {
      day: "Day 02",
      title: "Guruvayur - Munnar",
      content:
        "After morning breakfast, proceed to Munnar (230 kilometers / 4.5 hrs). Upon your arrival, get into the hotel and relax for sometime. Munnar is one of the most admired hill stations in Southern India, known for its sprawling tea estates. In the evening, relax and spend your overnight stay peacefully."
    },
    {
      day: "Day 03",
      title: "Munnar Sightseeing",
      content:
        "After morning breakfast, the tour guide will take you through the tea estates and the Mettupatty Dam for a boat ride, Kundala Lake, and Echo Point. Spend your overnight stay at the hotel."
    },
    {
      day: "Day 04",
      title: "Munnar - Periyar (Thekkady)",
      content:
        "Take your morning breakfast and proceed to Thekkady (120 kilometers / 3.5 hrs). Situated in the heart of the Cardamom Hills, the Periyar National Park is one of the most fascinating parks in the world. Enjoy a boat cruise on Periyar Lake to view the wide-ranging wildlife of this region. Overnight stay at the hotel."
    },
    {
      day: "Day 05",
      title: "Thekkady - Alleppey",
      content:
        "In the morning, drive to Alleppey (125 kms / 3.5 hrs). Check into the hotel and relax for sometime. Later, enjoy the famous Backwaters ride. Return to the hotel for an overnight stay."
    },
    {
      day: "Day 06",
      title: "Alleppey - Cochin",
      content:
        "After breakfast, proceed to Cochin (90 kms / 1.5 hrs). By noon, visit the Dutch Palace, Jewish Synagogue, Chinese Fishing Nets, and Santa Cruz Basilica. In the evening, enjoy a boat ride on the Sagar Rani. Overnight stay at the hotel."
    },
    {
      day: "Day 07",
      title: "Departure",
      content:
        "On the last day morning, transfer to Cochin Airport or Railway Station to board your flight or train for your onward journey."
    }
  ],  
    Goa: [
      {
        day: "Day 1",
        title: "Say hello to Goa",
        content: "Sandy beaches, swaying coconut palm trees, and laid-back fishing villages welcome you to this land on the first day of your Goa tour. An agent’s representative will greet you at the airport/railway station and transfer you to the hotel. Spend the first day leisurely, exploring the nightlife or relaxing at the sandy beaches. Return to the hotel for an overnight stay."
      },
      {
        day: "Day 2",
        title: "North Goa tour",
        content: "Wake up early for a dolphin sightseeing tour on the Arabian Sea. Afterward, enjoy a North Goa sightseeing tour, visiting Fort Aguada, Coco Beach, Calangute Annexe, Calangute Beach, Baga Beach, and Anjuna Beach. Return to the hotel for an overnight stay."
      },
      {
        day: "Day 3",
        title: "Explore South Goa",
        content: "Explore the charm of South Goa, beginning with Shri Shantadurga Temple at Kavlem and Shri Manguesh Temple at Priol. Visit the Basilicas of Bom Jesus and Se Cathedral in Old Goa, then head to Dona Paula Bay and Miramar Beach. Return to the hotel for an overnight stay."
      },
      {
        day: "Day 4",
        title: "Leisure day",
        content: "Enjoy a free day to relax at the hotel or explore more of Goa. Go souvenir shopping or try out some local Goan delicacies. This is your day to unwind and enjoy the relaxed atmosphere of Goa. Return to the hotel for an overnight stay."
      },
      {
        day: "Day 5",
        title: "Trip Ends",
        content: "Check-out from the hotel after breakfast and head to the airport/railway station for your return journey, taking with you sweet memories of your trip to Goa."
      }
    ],
    Ladakh: [
      {
        day: "Day 01",
        title: "Arrival in Leh",
        content:
          "After arrival at Leh Airport, you would be transferred to hotel for check-in. Today you are free for leisure & acclimatization. This way you can explore the Leh town and also become familiar with the high altitude climate. Overnight at hotel in Leh. Meal: breakfast"
      },
      {
        day: "Day 02",
        title: "Leh – Sangam – Hall of Fame – Leh",
        content:
          "Today after breakfast leave for half day excursion to Hall of Fame, Gurudwara Pathar Sahib, Magnetic Hill & Sangam View where Indus & Zanskar river meet. Afternoon you would be driven back to hotel. In the evening enjoy a sunset at Shanti Stupa. Night stay at hotel in Leh. Meal: breakfast and dinner"
      },
      {
        day: "Day 03",
        title: "Leh – Pangong Lake",
        content:
          "Today after breakfast, check out from the Hotel & drive to Pangong Lake, east to the Leh after crossing Changla Pass (17500ft) and driving via Durbuk and Tangtse villages in the Changthang region of Ladakh and perhaps one of the most amazing lakes in Asia which changes its color 4 – 5 times a day. At evening enjoy the breathtaking view of Pangong Lake. Overnight at the Camp at Pangong Lake. Meal: breakfast and dinner"
      },
      {
        day: "Day 04",
        title: "Pangong Lake – Leh",
        content:
          "Today after breakfast, check out from the Camp & drive to Leh. On the way visit Hemis, Shey and Thiksey monasteries. Evening free for leisure & own activities. Overnight at the Hotel. Meal: breakfast and dinner"
      },
      {
        day: "Day 05",
        title: "Leh - Khardungla Top - Nubra Valley",
        content:
          "Today after an early breakfast you would be driven to Nubra Valley. Enroute visit Khardung-la-pass, the highest motorable road in the world at 18,380ft. Nubra Valley is popularly known as Ldorma or the valley of flowers. It is situated to the north of Ladakh between the Karakoram and Ladakh ranges of the Himalayas. Arrive at Hunder & check in at Hotel/Camps. Later visit Diskit Village & enjoy the Camel ride on sand dunes. Dinner and overnight stay at Hotel/Camp. Meal: breakfast and dinner"
      },
      {
        day: "Day 06",
        title: "Nubra Valley – Leh",
        content:
          "Today after breakfast, drive to Leh after following the same route via Khardung-la. Check in at Hotel upon arrival. At evening explore Leh market for Shopping. Overnight at hotel. Meal: breakfast and dinner"
      },
      {
        day: "Day 07",
        title: "Depart Leh",
        content:
          "After Breakfast, check out from the Hotel & you would be transferred to Leh Airport. Your memorable tour to land of dragon concludes here. Meal: breakfast"
      }
    ],
    AndamanNicobar: [
      {
        day: "Day 1",
        title: "Port Blair",
        content: "Arrive at Port Blair where you will meet with our representative and be checked into your hotel. Start your holiday with a city tour covering the fisheries museum, anthropological museum, Samudrika museum, and Chatam island. In the evening, visit the historic Cellular Jail and enjoy the light and sound show depicting the saga of India's freedom struggle."
      },
      {
        day: "Day 2",
        title: "Havelock – Radhanagar Beach",
        content: "Transfer to Havelock Island by morning cruise/ferry. Visit the world-famous Radhanagar Beach known for its pristine white sand and turquoise waters. Enjoy a relaxing evening at your resort."
      },
      {
        day: "Day 3",
        title: "Havelock – Elephant Beach & Snorkeling",
        content: "Take a short boat ride to the beautiful Elephant Beach, known for its white sand and coral reef. Enjoy a free snorkeling session to explore the vibrant marine life. Relax for the rest of the day."
      },
      {
        day: "Day 4",
        title: "Neil Island – Beach Tour",
        content: "Transfer to Neil Island. After checking in, explore Sitapur Beach, Bharatpur Beach, and Laxmanpur Beach. Overnight stay at Neil Island."
      },
      {
        day: "Day 5",
        title: "Return to Port Blair – Corbyn's Cove Beach",
        content: "After a relaxed morning at your resort, take a cruise back to Port Blair. In the evening, visit Corbyn’s Cove Beach for a peaceful beach walk and relaxation."
      },
      {
        day: "Day 6",
        title: "Departure",
        content: "After breakfast, transfer to the airport for your return journey. Depart from the emerald islands with unforgettable memories."
      }
    ],
    GangtokNorthSikkim: [
      {
        day: "Day 1",
        title: "Arrival in Gangtok",
        content: "Arrive at NJP/IXB and transfer to Gangtok. Check into the hotel and relax. Explore MG Road or local markets in the evening. Gangtok is known for its rich biodiversity and stunning views of Kanchenjunga."
      },
      {
        day: "Day 2",
        title: "Tsomgo Lake and Baba Mandir Excursion",
        content: "Visit the serene Tsomgo Lake at 3780m and the inspiring Baba Mandir. Enjoy scenic beauty and spiritual vibes. Evening free for shopping at MG Road."
      },
      {
        day: "Day 3",
        title: "Transfer from Gangtok to Lachen",
        content: "Drive to Lachen via Chungthang. En route lunch stop. Lachen, at 2750m, is surrounded by majestic hills and is the gateway to the Green Lake trek. Check in and relax."
      },
      {
        day: "Day 4",
        title: "Gurudongmar Lake and Transfer to Lachung",
        content: "Visit Gurudongmar Lake, one of the highest lakes in the world at 17,100 ft. Continue the journey to Lachung, famed for its scenery and monastery. Visit Lachung Monastery in the evening."
      },
      {
        day: "Day 5",
        title: "Yumthang Valley Excursion",
        content: "Explore Yumthang Valley, known as the Valley of Flowers. Visit a nearby hot spring. In spring, enjoy a vibrant floral display; in winter, the valley is covered in snow. Return to Lachung for the night."
      },
      {
        day: "Day 6",
        title: "Return to Gangtok",
        content: "Drive back to Gangtok. Enjoy Himalayan views and Kanchenjunga en route. Free time in the evening to relax or shop at MG Road. Overnight in Gangtok."
      },
      {
        day: "Day 7",
        title: "Departure",
        content: "After breakfast, transfer to NJP railway station or Bagdogra airport for your return journey."
      }
    ],
    KashmirSummer: [
      {
        day: "Day 1",
        title: "Arrive in Srinagar",
        content: "Arrive at Srinagar Airport and transfer to a deluxe houseboat. Relax in the evening and enjoy views of the mountain ranges near Dal Lake. Dinner and overnight stay in houseboat."
      },
      {
        day: "Day 2",
        title: "Srinagar Local Sightseeing",
        content: "After breakfast, take a Shikara ride on Dal Lake, explore floating gardens, vegetable markets, and local vendors. Later, visit Mughal Gardens like Cheshma Shahi, Nishat Bagh, and Shalimar Bagh. Visit Shankaracharya Temple for panoramic views. Return to hotel for dinner and overnight stay."
      },
      {
        day: "Day 3",
        title: "Srinagar – Pahalgam – Srinagar",
        content: "After breakfast, head to Pahalgam, a scenic hill resort known for valleys like Aru, Kolhai Glacier, and Chandanwari. Explore temples and enjoy optional activities like horse riding and trekking. Return to Srinagar for dinner and overnight stay."
      },
      {
        day: "Day 4",
        title: "Srinagar – Gulmarg – Srinagar",
        content: "After breakfast, take an excursion to Gulmarg, a paradise for winter sports enthusiasts. Enjoy activities like skiing, cable car rides, and visit the highest golf course. Return to Srinagar for dinner and overnight stay."
      },
      {
        day: "Day 5",
        title: "Departure from Srinagar",
        content: "After breakfast, enjoy a brief local sightseeing tour of Srinagar before transferring to the airport for your onward journey."
      }
    ]
    ,
    RajasthanTour: [
      {
        day: "Day 1",
        title: "Arrival at Delhi",
        content: "Pickup from Delhi Airport/Railway/Bus Station. Check-in and visit Red Fort, Rashtrapati Bhawan, Jama Masjid, India Gate, Parliament House, Laxmi Narayan Temple, and Lotus Temple. Overnight stay at hotel."
      },
      {
        day: "Day 2",
        title: "Delhi to Mandawa",
        content: "Drive to Mandawa (257 km). Check-in and visit Shekhawati region including Nawalgarh, Mandawa, and Dundlod to explore traditional havelis. Overnight stay at hotel."
      },
      {
        day: "Day 3",
        title: "Mandawa to Bikaner",
        content: "Early morning drive to Bikaner. Visit Junagarh Fort and Lalgarh Museum. Overnight stay at hotel in Bikaner."
      },
      {
        day: "Day 4",
        title: "Bikaner to Jaisalmer",
        content: "Drive to Jaisalmer. Enjoy camel safari at Sam Sand Dunes and watch the sunset. Overnight stay at hotel."
      },
      {
        day: "Day 5",
        title: "Jaisalmer Sightseeing",
        content: "Full day sightseeing: Jaisalmer Fort, Museum, Jain Temple, Patwon ki Haveli, Kothari Haveli. Later visit Kulcihera and Sam Sand Dunes. Enjoy traditional Rajasthani camel rides. Overnight stay at hotel."
      },
      {
        day: "Day 6",
        title: "Jaisalmer to Jodhpur",
        content: "Drive to Jodhpur. Visit Mehrangarh Fort, Moti Mahal, and Phool Mahal. Overnight stay at hotel."
      },
      {
        day: "Day 7",
        title: "Jodhpur to Udaipur via Ranakpur",
        content: "Drive to Udaipur with enroute visit to Ranakpur Jain Temples and Sun Temple. Check in at hotel and overnight stay in Udaipur."
      },
      {
        day: "Day 8",
        title: "Udaipur Sightseeing",
        content: "Explore City Palace, Lake Pichola, Jag Mandir, Saheliyon ki Badi, and Jagdish Temple. Enjoy fine dining by the lake in the evening. Overnight stay at hotel."
      },
      {
        day: "Day 9",
        title: "Udaipur to Pushkar",
        content: "Drive to Pushkar. Visit Brahma Temple, Pushkar Lake, and Ghats. Overnight stay at hotel."
      },
      {
        day: "Day 10",
        title: "Pushkar to Jaipur",
        content: "Drive to Jaipur. Visit Chokhi Dhani in the evening for Rajasthani dinner and cultural performance. Overnight stay at hotel."
      },
      {
        day: "Day 11",
        title: "Jaipur Sightseeing & Departure",
        content: "Visit Amber Fort, City Palace, Hawa Mahal, and Jantar Mantar. After sightseeing, drop off at Jaipur Airport or Railway Station for departure."
      }
    ]
    
    
  };
  
  export default itineraries;
  